// extracted by mini-css-extract-plugin
export var active = "Carousel-module--active--8e00f";
export var animate = "Carousel-module--animate--2293a";
export var carouselControl = "Carousel-module--carouselControl--f8f6d";
export var container = "Carousel-module--container--71f95";
export var fill = "Carousel-module--fill--6e072";
export var pageIndicator = "Carousel-module--pageIndicator--4d6b0";
export var pagination = "Carousel-module--pagination--f56e0";
export var progressBar = "Carousel-module--progressBar--98c48";
export var track = "Carousel-module--track--26299";